import { Pipe, PipeTransform } from '@angular/core';
import { UserActionTypeMap } from '@common/constants';

@Pipe({
  name: 'userNameType',
  pure: true
})
export class UserActionTypePipe implements PipeTransform {
  transform(key: string): string {
    return UserActionTypeMap[key] ? UserActionTypeMap[key].displayName : '';
  }
}
